import { render, staticRenderFns } from "./DraggableTreeviewNode.vue?vue&type=template&id=103b4188&scoped=true"
import script from "./DraggableTreeviewNode.vue?vue&type=script&lang=js"
export * from "./DraggableTreeviewNode.vue?vue&type=script&lang=js"
import style0 from "./DraggableTreeviewNode.vue?vue&type=style&index=0&id=103b4188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103b4188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
